module.exports = __webpack_public_path__ + "static/grafik-design-43310172c47c4ea4efd742e2fa445611.png";